// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_check {
  display: block;
  box-sizing: border-box;
}
.container_check .check_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  padding: 50px;
}
.container_check .check_header .check_companyInfo {
  text-align: end;
  color: rgb(0, 0, 0);
}
.container_check .check_header .check_icon {
  font-size: 60px;
  color: rgb(0, 0, 0);
}
.container_check .check_header span,
.container_check .check_header h1,
.container_check .check_header h5 {
  color: rgb(0, 0, 0);
}
.container_check main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
}
.container_check main .shop_data {
  text-transform: uppercase;
}
.container_check footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
  color: rgb(0, 0, 0);
}
.container_check footer span,
.container_check footer h1 {
  color: rgb(0, 0, 0);
}

[data-theme=dark] .container_check {
  display: block;
  box-sizing: border-box;
}
[data-theme=dark] .container_check .check_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  padding: 50px;
}
[data-theme=dark] .container_check .check_header .check_companyInfo {
  text-align: end;
}
[data-theme=dark] .container_check .check_header .check_icon {
  font-size: 60px;
  color: #b3bdd1;
}
[data-theme=dark] .container_check .check_header span,
[data-theme=dark] .container_check .check_header h1,
[data-theme=dark] .container_check .check_header h5 {
  color: #b3bdd1;
}
[data-theme=dark] .container_check main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
}
[data-theme=dark] .container_check footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
}
[data-theme=dark] .container_check footer span,
[data-theme=dark] .container_check footer h1,
[data-theme=dark] .container_check footer h5 {
  color: #b3bdd1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/check.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAEJ;AADI;EACE,eAAA;EACA,mBAAA;AAGN;AADI;EACE,eAAA;EACA,mBAAA;AAGN;AADI;;;EAGE,mBAAA;AAGN;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AADI;;EAEE,mBAAA;AAGN;;AAEA;EACE,cAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAEJ;AADI;EACE,eAAA;AAGN;AADI;EACE,eAAA;EACA,cAAA;AAGN;AADI;;;EAGE,cAAA;AAGN;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAEJ;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AACJ;AAAI;;;EAGE,cAAA;AAEN","sourcesContent":[".container_check {\n  display: block;\n  box-sizing: border-box;\n  .check_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 200px;\n    padding: 50px;\n    .check_companyInfo {\n      text-align: end;\n      color: rgb(0, 0, 0);\n    }\n    .check_icon {\n      font-size: 60px;\n      color: rgb(0, 0, 0);\n    }\n    span,\n    h1,\n    h5 {\n      color: rgb(0, 0, 0);\n    }\n  }\n  main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px;\n    .shop_data {\n      text-transform: uppercase;\n    }\n  }\n  footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px;\n    color: rgb(0, 0, 0);\n    span,\n    h1 {\n      color: rgb(0, 0, 0);\n    }\n  }\n}\n\n[data-theme='dark'] .container_check {\n  display: block;\n  box-sizing: border-box;\n  .check_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 200px;\n    padding: 50px;\n    .check_companyInfo {\n      text-align: end;\n    }\n    .check_icon {\n      font-size: 60px;\n      color: #b3bdd1;\n    }\n    span,\n    h1,\n    h5 {\n      color: #b3bdd1;\n    }\n  }\n  main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px;\n  }\n\n  footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px;\n    span,\n    h1,\n    h5 {\n      color: #b3bdd1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
